module.exports = __webpack_public_path__ + "static/media/camp5.d98a093c.jpeg";